import React, { useContext } from 'react';
import { CaptainStoryData } from '../assets/dummyData/CaptainStoryData';
import CaptainStory from '../components/CaptainStory/CaptainStory';
import { Context } from '../context/Products';
import Helmet from '../components/Helmet';
import { seo } from '../assets/dummyData/seo';

const CaptainStoryPage = () => {
  const [{ lang }] = useContext(Context)
  return (
    <>
      <Helmet title={seo[lang].captainStory.title} metaDesc={seo[lang].captainStory.description} lang={lang} />
      <CaptainStory data={CaptainStoryData[lang]} />
    </>
  )
}

export default CaptainStoryPage;
